/* UI adapter only. Never grants a discount or substitutes for server validation. */
(function(root){
 const gift=item=>item.properties?._cl_bundle_gift!=null||item.properties?._cl_reward_gift==='true';
 const tier=item=>String(item.properties?._cl_bundle_gift??item.properties?._cl_reward_threshold??'');
 const cents=n=>Number.isSafeInteger(n)&&n>=0;
 const retiredCode='DOWNSELL1562577830102';
 function assertNoDownsell(cart){
  // Exact retired code only: never infer eligibility or rewrite customer codes.
  const exact=value=>String(value||'').trim().toUpperCase()===retiredCode;
  const applied=(cart.discount_codes||[]).some(d=>exact(d.code)&&d.applicable!==false)||
   [...(cart.cart_level_discount_applications||[]),...(cart.items||[]).flatMap(i=>
    [...(i.discount_allocations||[]),...(i.line_level_discount_allocations||[])].map(a=>a.discount_application))]
    .some(d=>d?.type==='discount_code'&&exact(d.title));
  if(applied)throw new Error('Eski %5 kapıda ödeme kodu bu akışta kullanılamaz. DOWNSELL1562577830102 kodunu kaldırıp yeniden deneyin. Diğer kuponlarınız korunur.');
 }
 function paidTotal(cart){
  if(!cents(cart?.total_price)||!Array.isArray(cart.items))throw new Error('Güncel sepet toplamı okunamadı.');
  const orderDiscounts=(cart.cart_level_discount_applications||[]).reduce((n,d)=>n+d.total_allocated_amount,0);
  let gifts=0;
  for(const item of cart.items.filter(gift)){
   if(!cents(item.final_line_price))throw new Error('Hediye satırı tutarı okunamadı.');
   if(item.final_line_price===0)continue;
   if(!orderDiscounts){gifts+=item.final_line_price;continue;}
   // final_line_price includes line discounts only. All allocations are needed
   // to split an order discount across charged gifts and paid merchandise.
   if(!Array.isArray(item.discount_allocations)||!cents(item.original_line_price))throw new Error('Hediye indirim dağılımı okunamadı.');
   const allocated=item.discount_allocations.reduce((n,a)=>{if(!cents(a.amount))throw new Error('Geçersiz indirim dağılımı.');return n+a.amount;},0);
   const total=item.original_line_price-allocated;
   if(!cents(total)||total>item.final_line_price)throw new Error('Hediye toplamı doğrulanamadı.');gifts+=total;
  }
  const paid=cart.total_price-gifts;
  if(!cents(paid))throw new Error('Ücretli ürün toplamı doğrulanamadı.');
  return paid;
 }
 async function reconcile({getCart,remove}){
  // A monotonic removal pass: never add gifts, mutate codes, or retry forever.
  for(let pass=0;pass<3;pass++){
   const cart=await getCart(),used=new Set(),removeKeys=[];
   // Remove charged gifts first. This avoids inventing an order allocation
   // when a COD/cart response doesn't include its full breakdown.
   const charged=cart.items.filter(i=>gift(i)&&i.final_line_price!==0);
   if(charged.length){await remove(charged.map(i=>i.key));continue;}
   const paid=paidTotal(cart);
   for(const item of cart.items.filter(gift)){
    const t=tier(item);
    if(!['4750','6750'].includes(t)||item.quantity!==1||used.has(t)||paid<Number(t)*100)removeKeys.push(item.key);
    else used.add(t);
   }
   if(!removeKeys.length){assertNoDownsell(cart);return cart;}
   await remove(removeKeys);
  }
  throw new Error('Sepet indirimleri değişti. Sepeti yenileyip yeniden deneyin.');
 }
 const api={paidTotal,reconcile,isGift:gift,assertNoDownsell};
 if(typeof module==='object'&&module.exports)module.exports=api;
 root.CraftlabelDiscountCompatibility=api;
})(typeof window==='object'?window:globalThis);

(function (root) {
  const marker = '_cl_auto_tshirt';
  const tier = item => String(item.properties?._cl_bundle_gift ?? item.properties?._cl_reward_threshold ?? '');
  const canonical = properties => JSON.stringify(Object.entries(properties || {}).filter(([key]) => key !== marker).sort(([a], [b]) => a.localeCompare(b)));
  const same = (a, b) => String(a.variant_id) === String(b.variant_id) && canonical(a.properties) === canonical(b.properties) && !a.selling_plan_allocation;
  const gift = item => item.properties?._cl_bundle_gift != null || item.properties?._cl_reward_gift === 'true';
  const automatic = (item, target) => item.properties?.[marker] === `${target}-v1`;
  const fingerprint = cart => JSON.stringify([cart.currency, cart.total_price, cart.discount_codes, cart.items.map(item => [item.variant_id, item.quantity, canonical(item.properties)])]);

  function create({ getCart, change, add, paidTotal, reward, family, properties }) {
    const attempted = new Set();
    async function restore(item, original) {
      const restored = { ...(original.properties || {}) };
      if (!Object.keys(restored).length) restored[marker] = 'restored';
      await change({ id: item.key, quantity: item.quantity, properties: restored });
      return getCart();
    }
    return async function reconcile() {
      let cart = await getCart();
      const definition = reward();
      const target = Number(definition?.target);
      if (![4750, 6750].includes(target) || cart.currency !== 'TRY' ||
          cart.items.some(item => gift(item) && tier(item) === String(target)) || paidTotal(cart) < target * 100) return cart;
      const isAutomatic = item => automatic(item, target);
      const signature = fingerprint(cart);
      if (attempted.has(signature)) return cart;
      attempted.add(signature);
      if (attempted.size > 100) attempted.delete(attempted.values().next().value);
      const products = family(definition);
      const original = cart.items.find(item => !gift(item) && !item.properties?._cl_reward_id && !item.selling_plan_allocation &&
        Number.isSafeInteger(item.quantity) && item.quantity > 0 && item.final_line_price > 0 &&
        products.some(product => String(product.productId) === String(item.product_id) &&
          product.variants?.some(variant => String(variant.id) === String(item.variant_id))));
      if (!original) return cart;
      const giftProperties = { ...properties(definition, original.properties), [marker]: `${target}-v1` };
      const beforeTotal = cart.total_price;
      const previousGifts = cart.items.filter(gift);
      const count = value => value.items.reduce((sum, item) => sum + item.quantity, 0);
      const beforeCount = count(cart);
      let split = false;
      try {
        if (original.quantity === 1) {
          await change({ id: original.key, quantity: 1, properties: giftProperties });
        } else {
          // Add first: stock/network failure must never remove a purchased unit.
          let addedFirst = true;
          try {
            await add({ id: original.variant_id, quantity: 1, properties: giftProperties });
          } catch (error) {
            cart = await getCart();
            const source = cart.items.find(item => same(item, original));
            if (error.status !== 422 || cart.items.some(isAutomatic) || source?.quantity !== original.quantity || count(cart) !== beforeCount) throw error;
            // At the stock limit, release exactly one unit, then reclaim it as
            // the gift. The outer recovery restores that unit on failure.
            await change({ id: source.key, quantity: source.quantity - 1 });
            split = true;
            await add({ id: original.variant_id, quantity: 1, properties: giftProperties });
            addedFirst = false;
          }
          cart = await getCart();
          if (addedFirst) {
            const source = cart.items.find(item => same(item, original));
            if (!source || source.quantity !== original.quantity) throw new Error('Sepet değişti. Lütfen yeniden deneyin.');
            await change({ id: source.key, quantity: source.quantity - 1 });
          }
          split = true;
        }
        cart = await getCart();
        const selected = cart.items.find(item => isAutomatic(item) && String(item.variant_id) === String(original.variant_id));
        const paid = paidTotal(cart);
        if (selected?.quantity === 1 && selected.final_line_price === 0 && paid >= target * 100 &&
            cart.total_price <= beforeTotal && count(cart) === beforeCount &&
            previousGifts.every(item => paid >= Number(tier(item)) * 100)) return cart;
        if (selected) cart = await restore(selected, original);
      } catch (error) {
        // A failed response may follow a committed mutation. Read before undoing.
        cart = await getCart();
        const selected = cart.items.find(item => isAutomatic(item) && String(item.variant_id) === String(original.variant_id));
        if (selected) {
          const source = cart.items.find(item => !gift(item) && same(item, original));
          if (original.quantity > 1 && !split && source?.quantity === original.quantity) {
            await change({ id: selected.key, quantity: 0 });
            cart = await getCart();
          } else cart = await restore(selected, original);
        } else if (original.quantity > 1 && count(cart) === beforeCount - 1) {
          const source = cart.items.find(item => !gift(item) && same(item, original));
          if (source?.quantity === original.quantity - 1) {
            await change({ id: source.key, quantity: original.quantity });
            cart = await getCart();
          }
        }
        // A failed stock reservation leaves the original purchase unchanged.
        if (count(cart) !== beforeCount) throw error;
      }
      attempted.add(fingerprint(cart));
      return cart;
    };
  }
  const api = { create };
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.CraftlabelAutoTshirt = api;
})(typeof window === 'object' ? window : globalThis);

(function(root){const CATALOG={"bisiklet-yaka":{"name":"Bisiklet yaka tişört","single":82500,"offers":[{"id":"pack3","quantity":3,"total":231000},{"id":"buy5pay4","quantity":5,"total":330000},{"id":"pack7","quantity":7,"total":455000},{"id":"pack10","quantity":10,"total":625000}]},"v-yaka":{"name":"V yaka tişört","single":82500,"offers":[{"id":"pack3","quantity":3,"total":231000},{"id":"pack5","quantity":5,"total":351000},{"id":"pack7","quantity":7,"total":462000},{"id":"pack10","quantity":10,"total":645000}]},"uzun-kollu-bisiklet-yaka":{"name":"Uzun kollu bisiklet yaka","single":96000,"offers":[{"id":"pack3","quantity":3,"total":259000},{"id":"pack5","quantity":5,"total":408000},{"id":"pack7","quantity":7,"total":538000},{"id":"pack10","quantity":10,"total":750000}]},"uzun-kollu-v-yaka":{"name":"Uzun kollu V yaka","single":96000,"offers":[{"id":"pack3","quantity":3,"total":259000},{"id":"pack5","quantity":5,"total":408000},{"id":"pack7","quantity":7,"total":538000},{"id":"pack10","quantity":10,"total":720000}]},"polo-yaka":{"name":"Polo yaka","single":96000,"offers":[{"id":"pack3","quantity":3,"total":258000},{"id":"pack5","quantity":5,"total":405000},{"id":"pack8","quantity":8,"total":600000}]},"triko-polo":{"name":"Triko polo","single":129000,"offers":[{"id":"pack3","quantity":3,"total":348000},{"id":"pack6","quantity":6,"total":648000}]},"sweatshirt":{"name":"Sweatshirt","single":102000,"offers":[{"id":"pack3","quantity":3,"total":279000},{"id":"pack5","quantity":5,"total":445000},{"id":"pack7","quantity":7,"total":595000}]},"hoodie":{"name":"Hoodie","single":108000,"offers":[{"id":"pack3","quantity":3,"total":294000},{"id":"pack5","quantity":5,"total":470000},{"id":"pack7","quantity":7,"total":630000}]},"jogger-pantolon":{"name":"Jogger pantolon","single":156000,"offers":[{"id":"pack3","quantity":3,"total":420000},{"id":"pack5","quantity":5,"total":660000},{"id":"pack7","quantity":7,"total":875000}]},"esofman-alti":{"name":"Eşofman altı","single":124000,"offers":[{"id":"pack3","quantity":3,"total":336000},{"id":"pack5","quantity":5,"total":525000}]},"kislik-baggy":{"name":"Kışlık Baggy","single":99000,"offers":[]},"yazlik-baggy":{"name":"Yazlık Baggy","single":99000,"offers":[{"id":"pack3","quantity":3,"total":267000}]}};
function optimizeGroup(units, group) {
  const catalog = CATALOG[group];
  if (!catalog || units.length > 1000) throw new Error('Unsupported group/quantity');
  const ordered = [...units].sort((a, b) => b.price - a.price || (a.lineId < b.lineId ? -1 : a.lineId > b.lineId ? 1 : a.index - b.index));
  const n = ordered.length;
  const prefix = [0];
  for (let i = 0; i < n; i++) prefix[i + 1] = prefix[i] + ordered[i].price;
  const offers = [...catalog.offers].sort((a, b) => b.quantity - a.quantity);
  const totals = new Array(n + 1);
  const counts = new Array(n + 1);
  const choices = new Array(n);
  totals[n] = 0; counts[n] = 0;
  for (let i = n - 1; i >= 0; i--) {
    let bestTotal = Infinity, bestCount = Infinity, best = -1;
    for (let j = 0; j < offers.length; j++) {
      const offer = offers[j];
      const end = i + offer.quantity;
      if (end > n) continue;
      const original = prefix[end] - prefix[i];
      const charge = offer.id === 'buy5pay4' ? original - ordered[end - 1].price : offer.total;
      if (charge > original) continue;
      const total = charge + totals[end], count = 1 + counts[end];
      if (total < bestTotal || (total === bestTotal && count < bestCount)) {
        bestTotal = total; bestCount = count; best = j;
      }
    }
    const singleTotal = ordered[i].price + totals[i + 1];
    const singleCount = counts[i + 1] + 1;
    if (singleTotal < bestTotal || (singleTotal === bestTotal && singleCount < bestCount)) {
      bestTotal = singleTotal; bestCount = singleCount; best = -1;
    }
    totals[i] = bestTotal; counts[i] = bestCount; choices[i] = best;
  }
  const assignments = [];
  for (let i = 0; i < n;) {
    const offer = choices[i] === -1 ? { id: 'single', quantity: 1 } : offers[choices[i]];
    const end = i + offer.quantity;
    assignments.push({ offer: offer.id, total: totals[i] - totals[end], units: ordered.slice(i, end) });
    i = end;
  }
  return { total: totals[0], assignments };
}


root.CraftlabelPricingReference={catalog:CATALOG,optimizeGroup,productGroups:{"8955615641814":"bisiklet-yaka","8955638972630":"bisiklet-yaka","8955640119510":"bisiklet-yaka","8955643232470":"bisiklet-yaka","8955643920598":"bisiklet-yaka","8955647426774":"bisiklet-yaka","8955647656150":"bisiklet-yaka","8955648344278":"bisiklet-yaka","8955649917142":"bisiklet-yaka","8955650343126":"bisiklet-yaka","8956109095126":"jogger-pantolon","8956111159510":"jogger-pantolon","8956113977558":"jogger-pantolon","8956115910870":"jogger-pantolon","8956118532310":"jogger-pantolon","8956131279062":"v-yaka","8956138291414":"v-yaka","8956146680022":"v-yaka","8956150350038":"v-yaka","8956227387606":"v-yaka","8956228960470":"v-yaka","8956232138966":"v-yaka","8956260450518":"v-yaka","8959573393622":"polo-yaka","8959576834262":"polo-yaka","8959578800342":"polo-yaka","8959579816150":"polo-yaka","8959580569814":"polo-yaka","8959581061334":"polo-yaka","8960302285014":"uzun-kollu-bisiklet-yaka","8960311001302":"uzun-kollu-bisiklet-yaka","8960311165142":"uzun-kollu-bisiklet-yaka","8960312606934":"uzun-kollu-bisiklet-yaka","8960316244182":"uzun-kollu-bisiklet-yaka","8960317587670":"uzun-kollu-bisiklet-yaka","8960319062230":"uzun-kollu-bisiklet-yaka","8960320733398":"uzun-kollu-bisiklet-yaka","8960366739670":"uzun-kollu-v-yaka","8960368115926":"uzun-kollu-v-yaka","8960369131734":"uzun-kollu-v-yaka","8960371327190":"uzun-kollu-v-yaka","8960376602838":"uzun-kollu-v-yaka","8960378339542":"uzun-kollu-v-yaka","8960383484118":"uzun-kollu-v-yaka","8960384401622":"uzun-kollu-v-yaka","8959577751766":"polo-yaka","8960929071318":"sweatshirt","8960935952598":"sweatshirt","8960937033942":"sweatshirt","8960937853142":"sweatshirt","8960938377430":"sweatshirt","8960942178518":"hoodie","8960947912918":"hoodie","8960949158102":"hoodie","8960949977302":"hoodie","8960951025878":"hoodie","8961144488150":"esofman-alti","8961146618070":"esofman-alti","8961148584150":"esofman-alti","9027177644246":"v-yaka","9027179315414":"v-yaka","9128805531862":"esofman-alti","9128809758934":"esofman-alti","9129486057686":"sweatshirt","9129486352598":"hoodie","9344522977494":"triko-polo","9344523075798":"triko-polo","9344523141334":"triko-polo","9344523174102":"triko-polo","9351101874390":"jogger-pantolon","9351122550998":"jogger-pantolon","9425521246422":"yazlik-baggy","9425521606870":"yazlik-baggy","9425521737942":"yazlik-baggy","9435381432534":"polo-yaka","9444045455574":"polo-yaka","9455882600662":"triko-polo","9455882928342":"triko-polo","9247413305558":"kislik-baggy","9247414255830":"kislik-baggy"}};})(window);
/* Presentation of applied Shopify prices only; never grants an offer. */
(function(root) {
  const cents = n => Number.isSafeInteger(n) && n >= 0;
  const isGift = item => item.properties?._cl_bundle_gift != null || item.properties?._cl_reward_gift === 'true';
  const tier = item => String(item.properties?._cl_bundle_gift ?? item.properties?._cl_reward_threshold ?? '');
  function giftValue(item, rewards) {
    if (!isGift(item) || item.quantity !== 1 || item.final_line_price !== 0) return 0;
    const reward = rewards.find(r => r.type === 'gift_product' && String(r.target) === tier(item));
    const products = reward?.giftProducts?.length ? reward.giftProducts : [reward?.giftProduct];
    const product = products.find(p => p && String(p.productId) === String(item.product_id));
    const variant = product?.variants?.find(v => String(v.id) === String(item.variant_id));
    return cents(variant?.price) ? variant.price : 0;
  }
  function describe(cart, rewards = [], reference = root.CraftlabelPricingReference) {
    const lines = new Map(), rows = [], groups = new Map();
    let giftSavings = 0;
    for (const item of cart.items || []) {
      const value = giftValue(item, rewards);
      const saving = Math.max(0, item.original_line_price - item.final_line_price);
      const allocations = (item.line_level_discount_allocations || []).filter(a => cents(a.amount) && a.amount > 0);
      const details = allocations.map(a => ({label:a.discount_application?.title || 'Ürün indirimi', amount:a.amount}));
      if (!details.length && saving) details.push({label:'Ürün indirimi', amount:saving});
      const free = isGift(item) && item.final_line_price === 0;
      if (free) {
        const label = `${Number(tier(item)).toLocaleString('tr-TR')} TL üzeri hediye`;
        details.splice(0, details.length, {label, amount:Math.max(value, saving), gift:true});
        rows.push({label:item.product_title || item.title, note:label, amount:Math.max(value, saving), gift:true});
        giftSavings += Math.max(0, value - item.original_line_price);
      }
      lines.set(item.key, {details, original:Math.max(item.original_line_price, value), final:item.final_line_price, free});
      const group = reference?.productGroups?.[String(item.product_id)];
      if (!isGift(item) && group && !item.selling_plan_allocation && cents(item.original_price) && item.original_line_price === item.original_price * item.quantity) {
        if (!groups.has(group)) groups.set(group, []);
        groups.get(group).push(item);
      }
    }
    const explained = new Set();
    for (const [group, items] of groups) {
      if (items.reduce((s,i)=>s+i.quantity,0)>1000) continue;
      const units = items.flatMap(i => Array.from({length:i.quantity},(_,index)=>({lineId:i.key,index,price:i.original_price})));
      const plan = reference.optimizeGroup(units, group);
      const original = items.reduce((s,i)=>s+i.original_line_price,0);
      const final = items.reduce((s,i)=>s+i.final_line_price,0);
      const own = items.reduce((s,i)=>s+(i.line_level_discount_allocations||[]).filter(a=>a.discount_application?.title==='Paket İndirimi').reduce((n,a)=>n+a.amount,0),0);
      // Matching both the actual allocation and the group net prevents a coupon
      // or a stale catalog from being presented as a package entitlement.
      if (!own || own !== original-plan.total || final !== plan.total) continue;
      const offers = plan.assignments.filter(a=>a.offer!=='single');
      const suffix={3:'lü',5:'li',6:'lı',7:'li',8:'li',10:'lu'};
      const labels = [...new Set(offers.map(a=>a.offer==='buy5pay4'?'5 al 4 öde':`${a.units.length}’${suffix[a.units.length]||'li'} paket`))];
      const label = labels.join(' + ');
      const singles = plan.assignments.filter(a=>a.offer==='single').length;
      rows.push({label:`${reference.catalog[group].name} · ${label}`, note:`${units.length} ürün${singles ? `; ${singles} adedi tekli fiyat` : ''}${items.length>1 ? '; indirim ürünlere paylaştırıldı' : ''}`,amount:own});
      for (const item of items) {
        const data=lines.get(item.key);
        data.details=data.details.map(d=>d.label==='Paket İndirimi'?{...d,label}:d);
        explained.add(item.key);
      }
    }
    for (const item of cart.items || []) {
      if (isGift(item) || explained.has(item.key)) continue;
      for (const d of lines.get(item.key).details) {
        const row=rows.find(r=>!r.gift && r.label===d.label && r.generic);
        if(row)row.amount+=d.amount;else rows.push({...d,generic:true});
      }
    }
    for (const d of cart.cart_level_discount_applications || []) {
      if(cents(d.total_allocated_amount)&&d.total_allocated_amount>0)rows.push({label:d.title||'Sepet indirimi',note:'Ürün indirimlerinden sonra',amount:d.total_allocated_amount,order:true});
    }
    const original = (cart.items || []).reduce((n,i)=>n+i.original_line_price,0)+giftSavings;
    return {lines,rows,original,total:cart.total_price,savings:original-cart.total_price,giftSavings};
  }
  const api={describe,giftValue,isGift,tier};
  if(typeof module==='object'&&module.exports)module.exports=api;
  root.CraftlabelDiscountDetails=api;
})(typeof window==='object'?window:globalThis);

/* Releasit v1 serializes catalog variants + discounts, not Cart Transform prices.
 * Represent verified zero-base gifts as explicit discounts in its local copy.
 * The Shopify cart and its discount selection are never modified here.
 */
(function(root) {
  const cents=n=>Number.isSafeInteger(n)&&n>=0;
  const canonical=p=>JSON.stringify(Object.entries(p||{}).sort(([a],[b])=>a.localeCompare(b)));
  const signature=cart=>JSON.stringify([cart.currency,cart.total_price,cart.items.map(i=>[String(i.variant_id),i.quantity,canonical(i.properties),i.original_line_price,i.final_line_price]).sort((a,b)=>JSON.stringify(a).localeCompare(JSON.stringify(b)))]);
  function resolvedDiscounts(cart) {
    let automatic=0;const codes=new Map();
    const add=(application,amount)=>{
      if(application?.target_type==='shipping_line')return;
      if(!cents(amount))throw new Error('İndirim dağılımı doğrulanamadı.');
      if(!amount)return;
      if(application?.type==='discount_code') {
        const code=String(application.title||'').trim();
        if(!code)throw new Error('Kupon adı okunamadı.');
        codes.set(code,(codes.get(code)||0)+amount);
      }else automatic+=amount;
    };
    for(const item of cart.items)for(const allocation of item.line_level_discount_allocations||[])add(allocation.discount_application,allocation.amount);
    for(const application of cart.cart_level_discount_applications||[])add(application,application.total_allocated_amount);
    const discounts=[...(automatic?[{text:'AUTOMATIC DISCOUNTS',amount:automatic,type:'fixed_amount'}]:[]),...[...codes].map(([text,amount])=>({text,amount,type:'fixed_amount'}))];
    if(discounts.reduce((n,d)=>n+d.amount,0)!==cart.original_total_price-cart.total_price)throw new Error('Sepetin indirim dağılımı eksik. Lütfen tekrar deneyin.');
    return discounts;
  }
  function normalize(cart,rewards,details=root.CraftlabelDiscountDetails) {
    if(cart._clCodPricing)throw new Error('Kapıda ödeme sepeti iki kez hesaplanamaz.');
    if(cart.currency!=='TRY'||!cents(cart.total_price))throw new Error('Kapıda ödeme tutarı doğrulanamadı.');
    const result=JSON.parse(JSON.stringify(cart));
    let adjustment=0;const seen=new Set();
    for(const item of result.items) {
      if(!details.isGift(item))continue;
      const tier=details.tier(item),value=details.giftValue(item,rewards);
      if(!['4750','6750'].includes(tier)||seen.has(tier)||item.quantity!==1||item.final_line_price!==0||cart.total_price<Number(tier)*100||!value)throw new Error('Hediye tutarı doğrulanamadı. Sepeti yenileyip tekrar deneyin.');
      seen.add(tier);
      const delta=value-item.original_line_price;
      if(delta<0)throw new Error('Hediye fiyatı değişti. Sayfayı yenileyin.');
      if(!delta)continue;
      adjustment+=delta;
      item.original_price=value;item.price=value;item.original_line_price=value;
      item.total_discount=(item.total_discount||0)+delta;
      item.line_level_total_discount=(item.line_level_total_discount||0)+delta;
      item.line_level_discount_allocations ||= [];
      item.line_level_discount_allocations.push({amount:delta,discount_application:{type:'automatic',title:`${Number(tier).toLocaleString('tr-TR')} TL üzeri hediye`,value_type:'fixed_amount',value:String(delta/100),allocation_method:'across',target_selection:'entitled',target_type:'line_item',total_allocated_amount:delta}});
    }
    result.original_total_price+=adjustment;
    result.total_discount=(result.total_discount||0)+adjustment;
    result._clCodPricing={signature:signature(cart),total:cart.total_price,adjustment,discounts:resolvedDiscounts(result)};
    return result;
  }
  function assertPayload(payload,view) {
    if(!view?._clCodPricing)throw new Error('Güncel sepet doğrulanamadı.');
    const data=payload?.cartData;
    if(!cents(data?.total_price)||!Array.isArray(data.discounts))throw new Error('Kapıda ödeme indirimleri okunamadı.');
    let discount=0;
    for(const d of data.discounts){if(d.type==='shipping')continue;if(d.type!=='fixed_amount'||!cents(d.amount))throw new Error('Kapıda ödeme indirimi doğrulanamadı.');discount+=d.amount;}
    if(data.total_price!==view.original_total_price||data.total_price-discount!==view._clCodPricing.total)throw new Error('Sepet ve kapıda ödeme tutarı eşleşmiyor. Sepeti yenileyip tekrar deneyin.');
    const ledger=discounts=>JSON.stringify(discounts.filter(d=>d.type!=='shipping'&&d.amount>0).map(d=>[d.text,d.amount,d.type]).sort((a,b)=>a[0].localeCompare(b[0])));
    if(ledger(data.discounts)!==ledger(view._clCodPricing.discounts))throw new Error('Kupon veya indirim kaydı değişti. Kapıda ödemeyi yeniden açın.');
    const fields=new Map();
    for(const field of payload.formData||[]){
      const itemField=/^item_(variant_id|quantity|properties)\[(\d+)\]$/.exec(field.name);
      if(/^item_(variant_id|quantity|properties)(?:\[|$)/.test(field.name)&&(!itemField||fields.has(field.name)||Number(itemField[2])>=view.items.length||String(Number(itemField[2]))!==itemField[2]))throw new Error('Kapıda ödeme ürün alanları yinelenmiş veya değişmiş. Sepeti yeniden açın.');
      fields.set(field.name,field.value);
    }
    if([...fields.keys()].filter(k=>/^item_variant_id\[\d+\]$/.test(k)).length!==view.items.length)throw new Error('Kapıda ödeme ürünleri değişti.');
    view.items.forEach((item,n)=>{
      const props=fields.get(`item_properties[${n}]`);
      if(String(fields.get(`item_variant_id[${n}]`))!==String(item.variant_id)||Number(fields.get(`item_quantity[${n}]`))!==item.quantity||canonical(props?JSON.parse(props):{})!==canonical(item.properties))throw new Error('Kapıda ödeme ürünleri değişti. Sepeti yeniden açın.');
    });
    return true;
  }
  const api={normalize,signature,assertPayload,resolvedDiscounts};
  if(typeof module==='object'&&module.exports)module.exports=api;
  root.CraftlabelCODPricing=api;
})(typeof window==='object'?window:globalThis);

/* Adapter for the observed Releasit v1 cartManager/getFormData contract. */
(function(root) {
  if(!root.document || root.CraftlabelCODBridge)return;
  const rewards=()=>JSON.parse(document.querySelector('[data-cl-cart-config]').textContent).rewards||[];
  const pricing=()=>root.CraftlabelCODPricing;
  const format=n=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format(n/100);
  const escape=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  async function freshCart() {
    // GET /cart.js (and an empty update) can retain a previous calculation.
    // Mutate only our private nonce so Shopify recalculates current offers.
    // Never replay quantities, notes or coupons from a potentially stale read.
    // This nonce is not a date, quote or discount authorization.
    const response=await (root.__clCartOriginalFetch||root.fetch)(
      (root.Shopify?.routes?.root||'/')+'cart/update.js',{
        method:'POST',credentials:'same-origin',cache:'no-store',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({attributes:{__cl_cod_refresh:Date.now()+':'+Math.random().toString(36).slice(2)}})
      });
    if(!response.ok)throw new Error('Güncel sepet tutarı hesaplanamadı. Lütfen tekrar deneyin.');
    const updated=await response.json();
    if(!Array.isArray(updated.items)||!Number.isSafeInteger(updated.total_price))throw new Error('Güncel sepet yanıtı doğrulanamadı.');
    return root.CraftlabelCart.prepareCheckout();
  }
  async function currentRewards(cart) {
    const definitions=rewards();
    const giftItems=cart.items.filter(root.CraftlabelDiscountDetails.isGift);
    const products=new Map();
    for(const item of giftItems){
      const definition=definitions.find(r=>String(r.target)===root.CraftlabelDiscountDetails.tier(item));
      const family=definition?.giftProducts?.length?definition.giftProducts:[definition?.giftProduct];
      const product=family.find(p=>p&&String(p.productId)===String(item.product_id));
      if(!product)throw new Error('Hediye ürünü doğrulanamadı. Sepeti yenileyin.');
      products.set(String(product.productId),product);
    }
    // A long-open page may have stale retail prices. Resolve the exact variants
    // again before representing their server-confirmed free price as a discount.
    await Promise.all([...products.values()].map(async product=>{
      const url=new URL(product.url,root.location.origin);url.pathname+='.js';url.searchParams.set('_cl_price',String(Date.now()));
      const response=await (root.__clCartOriginalFetch||root.fetch)(url,{cache:'no-store',credentials:'same-origin'});
      if(!response.ok)throw new Error('Hediye fiyatı okunamadı. Lütfen tekrar deneyin.');
      const current=await response.json();
      if(String(current.id)!==String(product.productId))throw new Error('Hediye ürünü değişti.');
      product.variants=product.variants.map(v=>({...v,price:current.variants.find(c=>String(c.id)===String(v.id))?.price}));
    }));
    return definitions;
  }
  function failure(error) {
    root._rsi?.form?.onClose?.(null,true);
    root.CraftlabelCart?.open();
    root.alert(error.message||'Sepet değişti. Tutarı kontrol edip tekrar deneyin.');
  }
  function decorate(rsi) {
    const view=rsi.cart;
    if(!view?._clCodPricing)return;
    const actual=view._clActualCart;
    const model=root.CraftlabelDiscountDetails.describe(actual,view._clRewards||rewards());
    document.querySelectorAll('#_rsi-cod-form-modal-form ._rsi-modal-line-item').forEach(row=>{
      const input=row.querySelector('input[name^="item_variant_id["]');
      const n=Number(input?.name.match(/\[(\d+)\]/)?.[1]);
      const item=actual.items[n],data=item&&model.lines.get(item.key);
      if(!data)return;
      const price=row.querySelector('._rsi-modal-line-item-final-price');
      if(price)price.innerHTML=`${data.original>data.final?`<s style="display:block;color:#666;font-size:12px">${format(data.original)}</s>`:''}<strong>${data.free?'Ücretsiz':format(data.final)}</strong>`;
      row.querySelector('[data-cl-cod-discount]')?.remove();
      const info=row.querySelector('._rsi-modal-line-item-info');
      if(info&&data.details.length)info.insertAdjacentHTML('beforeend',`<small data-cl-cod-discount style="display:block;color:#286049;margin-top:6px">${data.details.map(d=>`${escape(d.label)}${d.amount?` · −${format(d.amount)}`:''}`).join('<br>')}</small>`);
    });
    document.querySelector('[data-cl-cod-breakdown]')?.remove();
    const discountRow=document.querySelector('._rsi-modal-checkout-line[data-checkout-line="discount"]');
    if(discountRow&&model.rows.length)discountRow.insertAdjacentHTML('afterend',`<details data-cl-cod-breakdown style="font-size:12px;margin:8px 0"><summary style="cursor:pointer;text-decoration:underline">İndirim ve hediye detayları</summary>${model.rows.map(row=>`<div style="display:flex;justify-content:space-between;gap:12px;padding:5px 0"><span>${escape(row.label)}</span><strong style="white-space:nowrap">−${format(row.amount)}</strong></div>`).join('')}</details>`);
  }
  function install(rsi=root._rsi) {
    if(!rsi?.cartManager?.getCart||!rsi.form?.getFormData)return false;
    if(rsi.cartManager.getCart._clPricingBridge)return true;
    const originalLimit=rsi.form.discounts.getLimitToOneCodeDiscounts;
    rsi.form.discounts.getLimitToOneCodeDiscounts=function(){
      // The gift entry represents an already-zero Shopify price, not a second
      // competing offer. Retain Shopify's actual coupon names and allocations.
      // Releasit's one-code filter otherwise discards coupons beside that entry.
      const resolved=rsi.cart?._clCodPricing?.discounts;
      return resolved?resolved.map(d=>({...d})):originalLimit.apply(this,arguments);
    };
    const original=rsi.cartManager.getCart;
    function getCart(required,callback,cached,overwrite) {
      if(rsi.form.mode!=='normalCart')return original.apply(this,arguments);
      // Always read the real cart: a vendor cache may already contain the
      // retail-price view, or may predate a quantity/coupon/reward change.
      freshCart().then(async cart=>{
        const definitions=await currentRewards(cart);
        const view=pricing().normalize(cart,definitions);
        view._clActualCart=cart;
        view._clRewards=definitions;
        rsi.cart=view;rsi.cartFor.normalCart=view;
        callback(view);
        rsi.form.discounts.codesApplied=view._clCodPricing.discounts.map(d=>({...d}));
        rsi.form.discounts.updateTotalAmount(false,true);
        decorate(rsi);
      }).catch(failure);
    }
    getCart._clPricingBridge=true;
    rsi.cartManager.getCart=getCart;
    return true;
  }
  let submitting=false,opening=false;
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(form.id!=='_rsi-cod-form-modal-form')return;
    const rsi=root._rsi;
    if(rsi?.form?.mode!=='normalCart'&&!rsi?.cart?.items?.some(root.CraftlabelDiscountDetails.isGift))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(submitting)return;
    submitting=true;form.setAttribute('aria-busy','true');
    try {
      const cart=await freshCart();
      if(pricing().signature(cart)!==rsi.cart?._clCodPricing?.signature)throw new Error('Sepetiniz değişti. Güncel ürünleri ve tutarı kontrol edip kapıda ödemeyi yeniden açın.');
      const latest=pricing().normalize(cart,await currentRewards(cart));
      if(latest.original_total_price!==rsi.cart.original_total_price)throw new Error('Ürün fiyatı güncellendi. Kapıda ödemeyi yeniden açın.');
      if(Number(root.Shopify?.currency?.rate||1)!==1)throw new Error('Kapıda ödeme para birimi doğrulanamadı.');
      // Equal totals do not mean equal discount rights: a coupon may have
      // changed while the form was open. Compare with the fresh Shopify ledger.
      pricing().assertPayload(rsi.form.getFormData(),latest);
      if(!form.isConnected||typeof rsi.form.onSubmit!=='function')throw new Error('Kapıda ödeme formu değişti. Lütfen yeniden açın.');
      // Continue through the vendor's own validation/OTP/order handler exactly
      // once. Re-dispatching submit is intercepted by other storefront scripts.
      rsi.form.onSubmit.call(form,event);
    }catch(error){failure(error);}finally{submitting=false;form.removeAttribute('aria-busy');}
  },true);
  async function open(button) {
    if(opening)return false;
    opening=true;
    const label=button?.textContent;
    if(button){button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Hesaplanıyor…';}
    try {
      await freshCart();
      for(let n=0;n<80&&!install();n++)await new Promise(resolve=>setTimeout(resolve,125));
      if(!install())throw new Error('Kapıda ödeme formu yüklenemedi. Lütfen sayfayı yenileyin.');
      const rsi=root._rsi;
      if(rsi.s?.general?.formVersion!=='v1')throw new Error('Kapıda ödeme formu güncellendi. Lütfen online ödeme ile devam edin.');
      root._COD_FORM_ON_CART_PAGE_BUY_NOW_CLICK?.();
      rsi.form.mode='normalCart';
      root.CraftlabelCart.close();
      if(rsi.form.deferLoading)rsi.form.open(false,false,false,false,'cart=true');else rsi.form.open();
      return true;
    }catch(error){failure(error);return false;}
    finally{opening=false;if(button){button.disabled=false;button.removeAttribute('aria-busy');button.textContent=label;}}
  }
  root.CraftlabelCODBridge={install,open};
  root.CraftlabelOpenCODForm=open;
  // Native cart entry points also need the adapter before their first open.
  let tries=0;const timer=setInterval(()=>{if(install()||++tries>=160)clearInterval(timer);},125);
})(typeof window==='object'?window:globalThis);
